import { FC } from 'react';

const ViewModeHeader: FC<PropTypes> = ({ itens }) => (
  <thead className="view-mode-header">
    <tr>
      <th />

      {itens.map((item) => (
        <th key={item.key} className="view-mode-item">
          <h2 className="m-0">
            {item.current && (
              <i className="pi pi-circle-fill view-mode-item-icon" />
            )}
            {item.title}
          </h2>
          {item.subtitle && <span className="font-light">{item.subtitle}</span>}
        </th>
      ))}
    </tr>
  </thead>
);

export type ViewModeHeaderItem = {
  key: string | number;
  title: string;
  current?: boolean;
  subtitle?: string;
};

type PropTypes = {
  itens: ViewModeHeaderItem[];
};

export default ViewModeHeader;
